import { NgModule } from '@angular/core';
import { CacheService } from './services/cache.service';
import { NgCacheService } from './services/ng-cache.service';

@NgModule({
  providers: [CacheService, NgCacheService],
})
export class NimbusCacheModule {}
